// Asset types that only belong on certain assembly types (the backend enforces the
// same rules). Asset types that are not listed here can be linked to any assembly.
export const ASSET_TYPE_ASSEMBLY_TYPES = {
    'Electrical Schematics': ['Electrical Schematic'],
    'Pneumatic Schematics': ['Pneumatic Schematic'],
    'Filler Controller Manuals': ['Control Package', 'Electrical Schematic'],
};

export const canHoldAssetType = (assemblyType, assetType) => {
    const allowed = ASSET_TYPE_ASSEMBLY_TYPES[assetType];
    return !allowed || allowed.includes(assemblyType);
};
